import { COMPANY_FILTER_CHANGE } from '../../../PartnerOptions/constants'

import {
  ACTIVITY_FILTER_CHANGE,
  ADD_COMMENT_REPLY_REQUEST_ASYNC,
  BLOCKED_ATTACKS_ACTIVITY_LOG_REQUEST_ASYNC,
  CAMPAIGNS_ACTIVITY_LOG_REQUEST_ASYNC,
  COMMENTS_ACTIVITY_LOG_REQUEST_ASYNC,
  DISMISS_INSIGHTS_REQUEST_ASYNC,
  INCIDENTS_ACTIVITY_LOG_REQUEST_ASYNC,
  INSIGHTS_REQUEST_ASYNC,
} from './constants'

export default function () {
  const initialState = {
    activityLogData: {
      incidents: [],
      campaigns: [],
      comments: [],
      blockedAttacks: [],
    },
    insightsData: [],
    loader: false,
    error: null,
    activityLogFilter: 0,
    commentLoader: false,
    commentError: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
      case INCIDENTS_ACTIVITY_LOG_REQUEST_ASYNC.INITIATE:
      case CAMPAIGNS_ACTIVITY_LOG_REQUEST_ASYNC.INITIATE:
      case COMMENTS_ACTIVITY_LOG_REQUEST_ASYNC.INITIATE:
      case DISMISS_INSIGHTS_REQUEST_ASYNC.INITIATE:
      case BLOCKED_ATTACKS_ACTIVITY_LOG_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case INCIDENTS_ACTIVITY_LOG_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          activityLogData: {
            ...state.activityLogData,
            incidents: action.payload.data || [],
          },
          loader: false,
        }
      case INCIDENTS_ACTIVITY_LOG_REQUEST_ASYNC.ERROR:
      case CAMPAIGNS_ACTIVITY_LOG_REQUEST_ASYNC.ERROR:
      case COMMENTS_ACTIVITY_LOG_REQUEST_ASYNC.ERROR:
      case BLOCKED_ATTACKS_ACTIVITY_LOG_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error }
      case INCIDENTS_ACTIVITY_LOG_REQUEST_ASYNC.CANCEL:
      case CAMPAIGNS_ACTIVITY_LOG_REQUEST_ASYNC.CANCEL:
      case COMMENTS_ACTIVITY_LOG_REQUEST_ASYNC.CANCEL:
      case BLOCKED_ATTACKS_ACTIVITY_LOG_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case CAMPAIGNS_ACTIVITY_LOG_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          activityLogData: {
            ...state.activityLogData,
            campaigns: action.payload.data || [],
          },
          loader: false,
        }
      case COMMENTS_ACTIVITY_LOG_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          activityLogData: {
            ...state.activityLogData,
            comments: action.payload.data || [],
          },
          loader: false,
        }
      case BLOCKED_ATTACKS_ACTIVITY_LOG_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          activityLogData: {
            ...state.activityLogData,
            blockedAttacks: action.payload.data || [],
          },
          loader: false,
        }
      case ACTIVITY_FILTER_CHANGE:
        return { ...state, activityLogFilter: action.payload.value }
      case INSIGHTS_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case INSIGHTS_REQUEST_ASYNC.SUCCESS:
        return { ...state, insightsData: action.payload.data, loader: false }
      case INSIGHTS_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error }
      case INSIGHTS_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case DISMISS_INSIGHTS_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case ADD_COMMENT_REPLY_REQUEST_ASYNC.INITIATE:
        return { ...state, commentLoader: true, commentError: null }
      case ADD_COMMENT_REPLY_REQUEST_ASYNC.SUCCESS:
        return { ...state, commentLoader: false }
      case ADD_COMMENT_REPLY_REQUEST_ASYNC.ERROR:
        return { ...state, commentError: action.error, commentLoader: false }
      default:
        return state
    }
  }
}
